import moment from 'moment';

/**
 * Calculates the remaining time (in milliseconds).
 *
 * @param {string | Date} startDate - The start timestamp.
 * @param {number} timeLimitInMinutes - The time limit in minutes.
 * @returns {number} The remaining time in milliseconds.
 */
export function calculateRemainingTime(startDate: Date | string, timeLimitInMinutes: number): number {
  const now = moment();
  const createdAt = moment(startDate);
  const minutesSinceCreation = now.diff(createdAt, 'minutes');

  const timeRemainingInMinutes = timeLimitInMinutes - minutesSinceCreation;

  return timeRemainingInMinutes > 0 ? timeRemainingInMinutes * 60 * 1000 : 0;
}
